import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { EditIconComponent } from '@kuiper/icons';
import { AvatarComponent } from '../../../../../../ui-components/lib/avatar/avatar.component';
import { EMPLOYEE_ROUTES } from '../../../../constants/employee.routing.constants';
import { ProfileDropdownService } from '../../services/profile-dropdown.service';
import { AuthService } from '../../../../services/auth/auth.service';
import {
  VENDOR_MAIN_ROUTE,
  VENDOR_ROUTES,
} from '../../../../constants/vendor.routing.constants';
import { isVendorPortalUrl } from '../../../../helpers/portal/is-vendor-portal-url';

@Component({
  selector: 'lib-profile-dropdown-menu-header',
  imports: [AvatarComponent, EditIconComponent, RouterLink, TranslocoPipe],
  templateUrl: './profile-dropdown-menu-header.component.html',
  styleUrl: './profile-dropdown-menu-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileDropdownMenuHeaderComponent {
  readonly EMPLOYEE_ROUTES = EMPLOYEE_ROUTES;
  readonly VENDOR_ROUTES = VENDOR_ROUTES;
  readonly VENDOR_MAIN_ROUTE = VENDOR_MAIN_ROUTE;

  readonly profileDropdownService = inject(ProfileDropdownService);
  readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  user = this.authService.user;
  centralUser = this.authService.centralUser;
  selectedWorkspace = this.authService.selectedWorkspace;

  userName = computed(
    () =>
      this.user()?.name ??
      this.centralUser()?.first_name + ' ' + this.centralUser()?.last_name
  );
  userImage = computed(() => this.centralUser()?.image?.url);
  isVendor = computed(() => isVendorPortalUrl(this.router.url));

  closeDropdown() {
    this.profileDropdownService.isOpen.set(false);
  }
}
